/* import __COLOCATED_TEMPLATE__ from './status-dot.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

export type StatusDotState = 'success' | 'error' | 'syncing';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    classes: string;
  };
}

const StatusDotComponent = templateOnlyComponent<Signature>();

export default StatusDotComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::StatusDot': typeof StatusDotComponent;
    'knowledge-hub/filterable-list/table/cells/status-dot': typeof StatusDotComponent;
  }
}
